import React from "react";

/**
 * A button that reads as a link : the idiom for a secondary action
 * sitting INSIDE prose, where a real button would dominate the
 * paragraph explaining it.
 *
 * ONE owner of the treatment. It was hand-written at three sites -
 * Step 3's and Step 4's step-away save, and both actions in Step 2's
 * resume Alert - as the same 200-character class string. That is the
 * drift shape this folder has now extracted twice (useCopyFeedback,
 * then useConfigFileSave / StepAwaySave) : the next change to the
 * disabled colour or the focus ring would have landed on some copies
 * and missed others.
 *
 * A <button>, never an <a> : these run JavaScript and navigate
 * nowhere, so an anchor would be a lie to assistive technology and to
 * anyone middle-clicking it.
 *
 * @param {function} onClick  - the action
 * @param {boolean} [disabled] - greys it out and blocks the press
 * @param {React.ReactNode} children - the label
 */
function InlineLinkButton({ onClick, disabled = false, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="font-semibold text-link hover:underline disabled:text-muted disabled:cursor-not-allowed focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500 rounded-sm"
    >
      {children}
    </button>
  );
}

export default InlineLinkButton;
